"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestCacheNames = requestCacheNames;
function requestCacheNames() {
    return {
        caches: [],
    };
}
